import { Select } from '@mantine/core'
import { SelectProps } from '@mantine/core'

interface MyComponentProps
    extends Omit<SelectProps & React.RefAttributes<HTMLInputElement>, 'data'> {
    data?: []
    withAll?: boolean
}
const InputUserRole = ({
    withAll = false,
    label = 'ประเภทสิทธิการใช้งาน',
    classNames,
    value,
    styles,
    unstyled,
    className,
    defaultValue,
    ...others
}: MyComponentProps) => {
    const addlist = withAll === true ? [{ value: '', label: 'ทั้งหมด' }] : []

    return (
        <Select
            className={className}
            value={String(value)}
            placeholder='กรอกข้อมูล'
            label='ประเภทสิทธิการใช้งาน'
            data={[
                ...addlist,
                { value: '1', label: 'SUPER ADMIN' },
                { value: '2', label: 'ADMIN' },
                { value: '3', label: 'STAFF' },
            ]}
            {...others}
        />
    )
}

export default InputUserRole
